import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {BrandedLogin} from "./branded-login/branded-login";

export const BrandedLoginRoute = ({}) => cs(
    consumeContext("routerHistory"),
    consumeContext("themeScheme"),
    ({routerHistory, themeScheme}) => (
        <BrandedLogin routerHistory={routerHistory} themeScheme={themeScheme}  />    
    )
);